import React, { Fragment } from 'react'
import { Col, Container, Row } from 'reactstrap'
import ImageGalleryDescription from './ImageGalleryDescription'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs'
import { GalleryDescriptionTitle, GalleryTitle } from '../../../../Utils/Constants'

export default function GalleryDescriptionContainer() {
    return (
        <Fragment>
            <Breadcrumbs pageTitle={GalleryDescriptionTitle} parent={GalleryTitle} title={GalleryDescriptionTitle} />
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <ImageGalleryDescription />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
